var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 18.984 3.35 s 1.78 -0.694 1.632 0.993 c -0.05 0.694 -0.494 3.124 -0.84 5.753 l -1.188 7.787 s -0.099 1.14 -0.99 1.34 c -0.89 0.198 -2.225 -0.695 -2.472 -0.894 c -0.198 -0.149 -3.71 -2.38 -4.947 -3.472 c -0.346 -0.297 -0.742 -0.892 0.05 -1.587 l 5.193 -4.96 c 0.594 -0.595 1.188 -1.983 -1.286 -0.297 l -6.925 4.712 s -0.791 0.496 -2.275 0.05 l -3.216 -0.993 s -1.187 -0.744 0.841 -1.488 c 4.947 -2.33 11.031 -4.711 16.423 -6.943 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.6854bc16c165917913caba12efa018a2.svg";
export { ForwardRef as ReactComponent };